/* eslint-disable no-nested-ternary */
import { Box, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { trackWindowScroll } from 'react-lazy-load-image-component'
import 'swiper/css'
import 'swiper/css/navigation'
import { useVODStore } from '@/shared/store'
import { continueWatchingKeyword } from '@/shared/constants'
import { useVodItemsContext } from '@/features/VOD/context/UseGetVodItemContext/useVodItemsContext'
import VodSlider from './VodSlider'
import { VodRowViewProps } from '@/types/vod/vodRow'

const VodRowView = ({
    productId,
    title,
    handleGoToCategoryButtonClick,
    scrollPosition,
    maxHeight,
    hideCaptions,
    hideProgress,
    hideTitle,
    cardRadiusDp,
    rowHeightPercentage,
    isHomeContentRow,
}: VodRowViewProps) => {
    const itemsContainerRef = useRef<HTMLDivElement>(null)
    const vodItemHeight = maxHeight

    const { rowItems, getItems } = useVodItemsContext()

    const { isFetchContinuesWatching, setIsFetchContinuesWatching } =
        useVODStore()

    useEffect(() => {
        const rowElement = itemsContainerRef.current

        if (rowElement) {
            rowElement.addEventListener('scroll', () => getItems())
            return () =>
                rowElement.removeEventListener('scroll', () => getItems())
        }
    }, [])

    useEffect(() => {
        if (isFetchContinuesWatching && productId === continueWatchingKeyword) {
            getItems(continueWatchingKeyword)
            setIsFetchContinuesWatching(false)
        }
    }, [isFetchContinuesWatching])

    const categoryStyle = {
        color: 'white',
        typography: 'headline3',
        mb: '10px',
    }

    const rowViewContainerStyle = {
        position: 'relative',
        // width: '99%',
    }
    if (!rowItems.length) return <></>
    return (
        <Box onScroll={() => getItems()} sx={rowViewContainerStyle}>
            {!hideTitle && <Typography sx={categoryStyle}>{title}</Typography>}
            <VodSlider
                hideCaptions={hideCaptions}
                hideProgress={hideProgress}
                vodItemHeight={vodItemHeight}
                cardRadiusDp={cardRadiusDp}
                rowHeightPercentage={rowHeightPercentage}
                handleGoToCategoryButtonClick={handleGoToCategoryButtonClick}
                scrollPosition={scrollPosition}
                isHomeContentRow={isHomeContentRow}
            />
        </Box>
    )
}

export default trackWindowScroll(VodRowView)
